import { INIT_PAGINATION } from '@vindr/services/constants/common.constant';
import { PaginationProps } from '@vindr/services/interfaces';
import { isEmptyObject } from '@vindr/utils/helpers/common.helper';
import { ColumnType } from 'antd/es/table';

interface IndexColumnProps extends ColumnType<any> {
  pagination?: PaginationProps;
}

const IndexColumn = ({
  pagination,
  title = '#',
  width = 40,
  key = 'index',
  ...props
}: IndexColumnProps = {}): any => {
  return {
    title,
    width,
    align: 'center',
    key,
    render: (text, record, index) => {
      const { size, page } =
        isEmptyObject(pagination) || !pagination ? INIT_PAGINATION : pagination;

      return size * (page - 1) + index + 1;
    },
    ...props,
  };
};

export default IndexColumn;
